import { render, staticRenderFns } from "./ViewportOverlay.vue?vue&type=template&id=fd5a4e0c&scoped=true&"
import script from "./ViewportOverlay.vue?vue&type=script&lang=js&"
export * from "./ViewportOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ViewportOverlay.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ViewportOverlay.vue?vue&type=style&index=1&id=fd5a4e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5a4e0c",
  null
  
)

export default component.exports